export default "<div class=\"o-logo-group\">\n  {% block content %}{% endblock %}\n</div>\n";